import Link from 'next/link';
import styles from './ParentPosts.module.css';
import { ShotParent } from 'types/community';
import { getCommunityPath, getCommunityProfilePageUrl } from 'lib/community';

type ParentPostsProps = {
  parent?: ShotParent;
  root?: ShotParent | null;
};

export default function ParentPosts({ parent, root }: ParentPostsProps) {
  if (parent === undefined) {
    return null;
  }

  return (
    <div className={styles.PostsContainer}>
      <ParentPostItem
        title={parent.title}
        username={parent.username}
        slug={parent.slug}
        thumbnailUrl={parent.thumbnailUrl}
      />
      {root && parent.communityPostId !== root.communityPostId && (
        <ParentPostItem
          title={root.title}
          username={root.username}
          slug={root.slug}
          thumbnailUrl={root.thumbnailUrl}
          isRoot={true}
        />
      )}
    </div>
  );
}

type ParentLinkProps = {
  href: string;
  children: string;
};

function ParentLink({ href, children }: ParentLinkProps) {
  return (
    <Link href={href}>
      <a className={styles.Link}>{children}</a>
    </Link>
  );
}

type ParentPostItemProps = {
  title: string;
  username: string;
  slug: string;
  thumbnailUrl: string;
  isRoot?: boolean;
};
function ParentPostItem({
  title,
  username,
  slug,
  thumbnailUrl,
  isRoot = false,
}: ParentPostItemProps) {
  return (
    <div className={styles.Container}>
      <div className={styles.Content}>
        <div className={styles.RemixTitle}>
          {isRoot ? 'Originally' : 'Remix of'}{' '}
          <ParentLink href={getCommunityPath(slug)}>{title}</ParentLink>
        </div>
        <div className={styles.RemixOwner}>
          by{' '}
          <ParentLink href={getCommunityProfilePageUrl(username)}>
            {username}
          </ParentLink>
        </div>
      </div>
      <img className={styles.Image} src={thumbnailUrl} />
    </div>
  );
}
